import dayjs from 'dayjs';

export const parseToken = (token: string) => {
  if (!token) {
    return {};
  }
  const base64Payload = token.split('.')[1];
  const payload = Buffer.from(base64Payload, 'base64');
  const result = JSON.parse(payload.toString());
  return result;
};

export const isExpiredToken = (token: string) => {
  if (!token) {
    return true;
  }
  const result = parseToken(token);
  if (result.exp < new Date(dayjs(new Date()).tz('utc').format()).getTime() / 1000) {
    return true;
  }
  return false;
};
